import React from 'react';
import { ExamListContainer } from '../../containers';

const ExamListPage = () => <ExamListContainer />;

export default ExamListPage;
